import { render, staticRenderFns } from "./FeedbackModal.vue?vue&type=template&id=ac482384&scoped=true"
import script from "./FeedbackModal.vue?vue&type=script&lang=ts"
export * from "./FeedbackModal.vue?vue&type=script&lang=ts"
import style0 from "./FeedbackModal.vue?vue&type=style&index=0&id=ac482384&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac482384",
  null
  
)

export default component.exports